import { render, staticRenderFns } from "./MainPanelUI.vue?vue&type=template&id=3918e19a&scoped=true"
import script from "./MainPanelUI.vue?vue&type=script&lang=js"
export * from "./MainPanelUI.vue?vue&type=script&lang=js"
import style0 from "./MainPanelUI.vue?vue&type=style&index=0&id=3918e19a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918e19a",
  null
  
)

export default component.exports